import { nuovaSessioneComunicazioni } from "./comunicazioniLettura";

class sessionStorageService {
  lc = window.localStorage;
  ss = window.sessionStorage;

  setItem(key, value) {
    // I login normali ed esterni scrivono auth_user; il ripristino con F5 lo legge soltanto.
    if (key === "auth_user") {
      const auth = typeof value === "string" ? JSON.parse(value) : value;
      if (auth?.accessToken || auth?.token) nuovaSessioneComunicazioni();
    }
    value = JSON.stringify(value)
    this.ss.setItem(key, value)
    return true
  }

  getItem(key) {
    let value = this.ss.getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  }
  
  removeItem(key) {
    this.ss.removeItem(key);
  }

  clear() {
    this.ss.clear();
    this.lc.clear();
  }
}

export default new sessionStorageService();
